const sectionsSource = {
  type: 'geojson',
  data: {
    type: 'FeatureCollection',
    features: [
      {
        id: 'label_cut',
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [-75.16778422893366, 39.96156991527073]
        },
        properties: {
          anchor: 'bottom-left',
          icon: 'cut'
        }
      },
      {
        id: 'label_phase',
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [-75.15838971126169, 39.95931406667063]
        },
        properties: {
          anchor: 'top-right',
          icon: 'phase'
        }
      },
      {
        id: 'label_tunnel',
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [-75.18028993842206, 39.96853756739617]
        },
        properties: {
          anchor: 'bottom-left',
          icon: 'tunnel'
        }
      },
      {
        id: 'label_viaduct',
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [-75.1512580704901, 39.96297326918781]
        },
        properties: {
          anchor: 'top-left',
          icon: 'viaduct'
        }
      }
    ]
  }
}

const sectionsIcons = [
  { src: window.SITE_BASE + '/assets/images/label_cut.svg', name: 'cut' },
  { src: window.SITE_BASE + '/assets/images/label_phase.svg', name: 'phase' },
  { src: window.SITE_BASE + '/assets/images/label_tunnel.svg', name: 'tunnel' },
  { src: window.SITE_BASE + '/assets/images/label_viaduct.svg', name: 'viaduct' }
]

export {
  sectionsSource,
  sectionsIcons
}